import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';

import type {
  LC_GetAttendanceConceptHandlingsOut,
  LC_GetAttendanceConceptFormulasOut,
  AttendanceConceptHandling,
  AttendanceConceptFormula,
} from './attendanceConceptCatalog.types';
import {
  mapAttendanceConceptHandling,
  mapAttendanceConceptFormula,
} from './attendanceConceptCatalog.mapper';


export class AttendanceConceptCatalogService {
  async getHandlings(signal?: AbortSignal): Promise<ApiResponse<AttendanceConceptHandling[]>> {
    const response = await apiClient.get<LC_GetAttendanceConceptHandlingsOut>(
      API_CONFIG.ENDPOINTS.CATALOG.ATTENDANCE_CONCEPT_HANDLINGS,
      { signal },
    );

    if (response.success && response.data) {
      return { ...response, data: response.data.map(mapAttendanceConceptHandling) };
    }

    return { ...response, data: null };
  }

  async getFormulas(signal?: AbortSignal): Promise<ApiResponse<AttendanceConceptFormula[]>> {
    const response = await apiClient.get<LC_GetAttendanceConceptFormulasOut>(
      API_CONFIG.ENDPOINTS.CATALOG.ATTENDANCE_CONCEPT_FORMULAS,
      { signal },
    );

    if (response.success && response.data) {
      return { ...response, data: response.data.map(mapAttendanceConceptFormula) };
    }

    return { ...response, data: null };
  }
}

export const attendanceConceptCatalogService = new AttendanceConceptCatalogService();
